module.exports = __webpack_public_path__ + "static/media/Team-3.709fbf66.jpg";